/*global Daon */
/*eslint no-undef: "error"*/

import { Component } from "react"
import { connect } from "react-redux"
import { instanceOf } from "prop-types";

import { createInstance } from "../../logic/actions/livenessTest"

export class WebCLRLoader extends Component {
  static propTypes = {
    CLRCaptureInstance: instanceOf(Daon.CLRCapture)
  }

  componentDidMount() {
    if (!this.props.CLRCaptureInstance) this.props.createInstance()
  }

  render() { return null; }
}

export default connect(state => {
  return state.livenessTest
}, { createInstance })(WebCLRLoader)